export default {
  title: 'Ansaitse pisteitä ja palkintoja',
  header: {
    pickup: 'Nouto 5 minuutissa',
  },
  recommendations: {
    title: 'Suositeltu',
  },
  discounts: {
    title: 'Alennukset',
    data: [
      {
        title: '+125 lisäpistettä',
        description: 'Arvioi meidät Googlessa',
      },
      {
        title: '+{{amount}} alennus',
        description: '+{{amount}} alennus, kun maksat koodilla {{code}}',
      },
    ],
    button: {
      add: '+ Lisää',
    },
  },
  rewards: {
    title: 'Palkinnot ja kupongit',
    balance: 'Saldo',
    points: 'Pisteet',
  },
};
